import React from "react";
import { Controller } from "react-hook-form";
import Form from "../../Form";
import { TextInput, SelectInput } from "djinn-components";
import FormFieldErrors from "../../Form/FormFieldErrors";
import { useSiteState } from "../../../utils/useSiteState";
import { useNavigate } from "react-router-dom";

const CreatePageForm: React.FC = () => {
  const { site } = useSiteState();

  const navigate = useNavigate();
  const getDefaults = () => {
    return {
      title: "",
    };
  };

  const onSubmit = async ({ id }: any) => {
    navigate(`/${site.id}/pages/${id}`);
  };

  const types = [
    { key: "Plain", value: "plain" },
    { key: "Policy Page", value: "policy" },
    { key: "Support Page", value: "support" },
  ];

  return (
    <Form
      getDefaults={getDefaults}
      onCompleted={onSubmit}
      buttonTitle="Create page"
      endpoint={`sites/${site.id}/pages`}
      method="post"
      className="w-full"
      render={({ errors, control }) => (
        <>
          <div className="mb-4">
            <label className="mb-2 block ml-4 text-sm font-medium">
              Page Title
            </label>
            <Controller
              name="title"
              control={control}
              defaultValue=""
              rules={{
                required: true,
              }}
              render={({ field: { onChange, value } }: any): JSX.Element => (
                <TextInput
                  value={value}
                  onChange={onChange}
                  invalid={!!errors.title}
                  placeholder="Page Title"
                />
              )}
            />

            <FormFieldErrors
              errors={errors}
              field="title"
              requiredMessage="Page title is required"
            />
          </div>

          <div className="mb-4">
            <label className="mb-2 block ml-4 text-sm font-medium">
              Page Template
            </label>
            <Controller
              name="template"
              control={control}
              defaultValue=""
              rules={{
                required: true,
              }}
              render={({ field: { onChange, value } }: any): JSX.Element => (
                <SelectInput
                  selected={value}
                  onSelect={onChange}
                  invalid={!!errors.template}
                  label="Page Type"
                  options={types}
                />
              )}
            />

            <FormFieldErrors
              errors={errors}
              field="template"
              requiredMessage="Page type is required"
            />
          </div>
        </>
      )}
    />
  );
};

export default CreatePageForm;
